import { Link } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import AnimeCard from "@/components/feature/AnimeCard";
import { animeList, weekDays, todayDay } from "@/mocks/anime";

export default function Calendar() {
  const total = animeList.length;

  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "妖精动漫网追番日历",
    url: "https://comicnot.github.io/calendar",
    inLanguage: "zh-CN",
    description: "按周一至周日查看正在更新的连载动漫，快速定位最新话。",
    numberOfItems: total,
    itemListElement: animeList.map((a, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: a.title,
      url: `https://comicnot.github.io/anime/${a.id}`,
    })),
  };

  return (
    <>
      <Header />
      <main className="bg-background-50">
        <section className="bg-background-100 py-8 md:py-12">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <nav aria-label="面包屑" className="text-xs text-foreground-600">
              <ol className="flex flex-wrap items-center gap-1.5">
                <li>
                  <Link to="/" className="hover:text-primary-600">首页</Link>
                </li>
                <li>/</li>
                <li aria-current="page" className="text-foreground-500">追番日历</li>
              </ol>
            </nav>
            <h1 className="mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">追番日历</h1>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
              本周共 {total} 部连载动漫正在更新。按星期快速定位正在更新的作品，带“今天”标记的即当天更新，点开即可看最新话。
            </p>
          </div>
        </section>

        <section className="py-8 md:py-12">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
              {weekDays.map((day) => {
                const items = animeList.filter((a) => a.day === day);
                const isToday = day === todayDay;
                return (
                  <section
                    key={day}
                    id={day}
                    className={`scroll-mt-20 rounded-lg border p-5 ${
                      isToday ? "border-accent-300 bg-accent-100/50" : "border-background-200 bg-background-50"
                    }`}
                  >
                    <div className="mb-4 flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <h2 className="text-base font-bold text-foreground-950">{day}</h2>
                        <span className="text-xs text-foreground-500">{items.length} 部更新</span>
                      </div>
                      {isToday && (
                        <span className="rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
                          今天
                        </span>
                      )}
                    </div>
                    {items.length > 0 ? (
                      <div className="grid grid-cols-2 gap-3">
                        {items.map((anime) => (
                          <AnimeCard key={anime.id} anime={anime} />
                        ))}
                      </div>
                    ) : (
                      <p className="py-6 text-center text-sm text-foreground-500">今日无更新</p>
                    )}
                  </section>
                );
              })}
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
    </>
  );
}